// Independent demo verified over public HTTPS before this integration.
// This value is a public URL, never a credential. No production integration.
const restaurantUrl = process.env.REACT_APP_RESTAURANT_DEMO_URL || "https://rodeia-mesa-do-largo-demo.netlify.app/";

export const demonstrations = [
  {
    id: "restaurantes",
    segment: "Restaurantes",
    title: "Ementa digital e atendimento interativo",
    description:
      "Explore o restaurante fictício Mesa do Largo: uma experiência simples para descobrir pratos, tirar dúvidas e simular um pedido de mesa.",
    benefits: [
      "Ementa com pesquisa e categorias",
      "Português e inglês no mesmo Web App",
      "Atendimento e pedidos de mesa demonstrativos",
    ],
    formats: ["Site", "Web App", "Atendimento digital"],
    url: /^https:\/\/[^\s]+$/i.test(restaurantUrl) ? restaurantUrl : null,
  },
];
